import moment from 'moment-timezone';

export class EnterpriseDashboardBudgetChartData {
	public date: Date;
	public actualCost: number;
	public currentBudgetCost: number;

	constructor(enterpriseDashboardBudgetChartData?: EnterpriseDashboardBudgetChartData) {
		Object.assign(this, enterpriseDashboardBudgetChartData);

		this.date = this.date ? new Date(moment(this.date).format('MMM DD, YYYY 00:00:00 a')) : this.date;
	}
}
